import { Controller } from "@hotwired/stimulus"

// Change-time form: when the start time changes, set the end time 30 minutes
// later. Past midnight it wraps (23:45 -> 00:15); the server reads an end
// before the start as the next day.
export default class extends Controller {
  static targets = ["start", "end"]

  startChanged() {
    const [h, m] = this.startTarget.value.split(":").map(Number)
    if (Number.isNaN(h) || Number.isNaN(m)) return

    const total = (h * 60 + m + 30) % (24 * 60)
    const pad = (n) => String(n).padStart(2, "0")
    this.endTarget.value = `${pad(Math.floor(total / 60))}:${pad(total % 60)}`
  }
}
